import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instantly jump to top without animation
    requestAnimationFrame(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  });
  }, [pathname]);

  return null; // No UI
};

export default ScrollToTop;
